/* tslint:disable */
/* eslint-disable */
/* @relayHash 22da2a36b69ed41c61d9840f022d0317 */

import { ConcreteRequest } from "relay-runtime";
export type UploadFileToVerifyInput = {
    automatedVerificationID: string;
    delegateUUID: string;
    fileStage: string;
    filename: string;
    uploadMeta: UploadFileMeta;
};
export type UploadFileMeta = {
    fileType: string;
    contentLength: number;
};
export type UploadFilesMutationVariables = {
    input: UploadFileToVerifyInput;
};
export type UploadFilesMutationResponse = {
    readonly uploadFileToVerify: {
        readonly successToken: string;
        readonly url: string;
    };
};
export type UploadFilesMutation = {
    readonly response: UploadFilesMutationResponse;
    readonly variables: UploadFilesMutationVariables;
};



/*
mutation UploadFilesMutation(
  $input: UploadFileToVerifyInput!
) {
  uploadFileToVerify(input: $input) {
    successToken
    url
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "input",
            "type": "UploadFileToVerifyInput!",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "uploadFileToVerify",
            "storageKey": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "UploadFileResp",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "successToken",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "url",
                    "args": null,
                    "storageKey": null
                }
            ]
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "UploadFilesMutation",
            "type": "Mutation",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "operation": {
            "kind": "Operation",
            "name": "UploadFilesMutation",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "params": {
            "operationKind": "mutation",
            "name": "UploadFilesMutation",
            "id": null,
            "text": "mutation UploadFilesMutation(\n  $input: UploadFileToVerifyInput!\n) {\n  uploadFileToVerify(input: $input) {\n    successToken\n    url\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '0d94b47310950105d92eb6f85dd05c1c';
export default node;
